import { render, staticRenderFns } from "./AlgorithmList.vue?vue&type=template&id=55a3f55c&scoped=true"
import script from "./AlgorithmList.vue?vue&type=script&lang=js"
export * from "./AlgorithmList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3f55c",
  null
  
)

export default component.exports